import {
  Customer,
  CustomerStatus,
  CustomerStatusType,
  CustomerEntityType as CustomerTypes,
  type CustomerEntityType,
} from 'types/customers'
import {
  EmbeddedCustomerAgreementStatuses,
  EmbeddedCustomerStatuses,
  EmbeddedCustomerTypes,
} from './constants'
import {
  AgreementStatusHighlight,
  EmbeddedCustomer,
  EmbeddedCustomerAgreementStatus,
} from './types'

export const getMappedCustomerType = (customerTypeData: CustomerEntityType) => {
  if (customerTypeData === CustomerTypes.COMPANY) return EmbeddedCustomerTypes.BUSINESS
  return EmbeddedCustomerTypes.INDIVIDUAL
}

export const getMappedCustomerStatus = (customerStatusData: CustomerStatusType) => {
  switch (customerStatusData) {
    case CustomerStatus.PENDING:
      return EmbeddedCustomerStatuses.ACTION_REQUIRED
    case CustomerStatus.VERIFIED:
      return EmbeddedCustomerStatuses.AGREEMENTS_ACCEPTED
    default:
      return EmbeddedCustomerStatuses.KYB_PENDING
  }
}

export const getMappedCustomerList = (customerData: Customer[]): EmbeddedCustomer[] => {
  return customerData?.map(customerData => ({
    id: customerData?.reference,
    type: getMappedCustomerType(customerData?.type),
    status: getMappedCustomerStatus(customerData?.status),
    name: customerData?.name,
    description: customerData?.description,
  }))
}

export const getAgreementStatusHighlight = (
  status: EmbeddedCustomerAgreementStatus
): AgreementStatusHighlight => {
  switch (status) {
    case EmbeddedCustomerAgreementStatuses.SIGNED:
      return { type: 'success', label: 'statusLabel.accepted' }
    case EmbeddedCustomerAgreementStatuses.DECLINED:
      return { type: 'error', label: 'statusLabel.declined' }
    default:
      return { type: 'warning', label: 'statusLabel.pending' }
  }
}
